import { u, styled } from '../../shared/theming-sc'

const Overlay = styled.div`
  position: fixed;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  z-index: 100;
  overflow-y: auto;
  background-color: rgba(102,102,102, 0.9);

  ${u.media.lessThan('sm')`
    overflow-y: hidden;
  `}
`

const DialogOuter = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  vertical-align: middle;
  text-align: center;

  &:before{
    content: '';
    display: inline-block;
    height: 100%;
    vertical-align: middle;
    margin-right: -4px;
  }
`

const Dialog = styled.div`
  background: white;
  position: relative;
  margin: 40px auto;
  width: 840px;
  display: inline-block;
  vertical-align: middle;


  ${u.media.lessThan('lg')`
    margin-top: 0;
    margin-bottom: 0;
    width: auto;
    position: fixed;
    top: ${u.getSpacing('large')}px;
    right: ${u.getSpacing('large')}px;
    bottom: ${u.getSpacing('large')}px;
    left: ${u.getSpacing('large')}px;
    transform: none;
  `}

  ${u.media.lessThan('sm')`
    overflow-y: scroll;
    position: absolute;
  `}
`

const Wrapper = styled.div`
  text-align: center;
  width: 500px;
  margin: 0 auto;
  text-align: center;

  ${u.media.lessThan('lg')`
    width: 100%;
    position: relative;
    box-sizing: border-box;
    padding: ${u.getSpacing('large')}px;

  `}
`

const Header = styled.div`
  width: 40px;
  height: 40px;
  margin: 20px auto 10px auto;

  ${u.media.lessThan('lg')`
    display: none
  `}
`

const Body = styled.div`
`

const Close = styled.a`
  width: 23px;
  height: 23px;
  position: absolute;
  right: 20px;
  top: 20px;
  z-index: 1000;
`

const IconWrapper = styled.span`
  color: '#FF8000';
  vertical-align: 'middle';
  width: '40px';
  height: '40px';
`

export {
  Overlay,
  Dialog,
  DialogOuter,
  Wrapper,
  Header,
  Body,
  Close,
  IconWrapper
}
